export default function setUpCanvas(canvas) {
  const el = canvas;
  const { parentRect } = {
    parentRect: el.parentElement.getBoundingClientRect(),
  };
  const devicePixelRatio = Window.devicePixelRatio || 1;

  const { height, width } = {
    height: parentRect.height,
    width: parentRect.width,
  };

  el.width = width * devicePixelRatio;
  el.height = height * devicePixelRatio;
  el.style.width = '';
  el.style.height = '';
}
